import { useMutation } from "@tanstack/react-query";
import { getDayActivities } from "../../queries/ScheduleHub";

export const useGetHubDailyActivity = () => {
  const { mutate, isPending, isError, data } = useMutation({
    mutationKey: ['getHubDailyActivity'],
    mutationFn: (idCronograma: string) => getDayActivities(idCronograma),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};  